<template>
	<LoginLayout
		form-title="SSO logout"
	>
		<template #form>
			<Message type="info">
				You have been logged out successfully.
			</Message>
			<a @click="$router.push({ path: '/login' })">
				Log in.
			</a>
		</template>
	</LoginLayout>
</template>
<script>
import LoginLayout from '../../../../shared/layouts/login-layout.vue'
import Message from '../../../../shared/components/message.vue'
import { clearClientSessionArtifacts } from '../../state/modules/auth.js'
export default {
	components: { Message, LoginLayout },
	mounted () {
		this.$store?.commit('auth/SET_CURRENT_USER', null)
		this.$store?.commit('auth/SET_SESSION_WARNING', false)
		this.$store?.commit('auth/SET_COUNTDOWN', 0)
		try {
			clearClientSessionArtifacts()
		} catch (error) {
			if (process.env.NODE_ENV !== 'production') {
				console.warn('[sso-logout] failed to clear auth artifacts', error)
			}
		}
	}
}
</script>
